import { setTags, setUser } from '@sentry/browser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../AuthContext';

export const useSentryUser = () => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const { id: userId, workspaceId, organizationId } = user;
  const language = i18n.resolvedLanguage;

  useEffect(() => {
    setUser(userId ? { id: String(userId) } : null);
    setTags({
      workspaceId: workspaceId ? String(workspaceId) : undefined,
      organizationId: organizationId ? String(organizationId) : undefined,
      language,
    });
  }, [userId, workspaceId, organizationId, language]);
};
